import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["recipients", "receiverInput", "container", "button"]
    static values = { count: Number, open: { type: Boolean, default: false } }

    connect() { this.update() }

    update() {
        console.log("Update visibility");
        const selected = this.element.querySelector('input[name="rbf_claim_comment[visibility]"]:checked')?.value || "public"
        const show = selected === "custom"
        this.recipientsTarget.classList.toggle("hidden", !show)
        this.receiverInputTargets.forEach(cb => {
            cb.disabled = !show
            if (!show) cb.checked = false
        })
    }

    toggle(event) {
        event.preventDefault()
        this.openValue = !this.openValue
        this.containerTarget.classList.toggle("hidden", !this.openValue)
        this.buttonTarget.textContent = this.openValue
            ? "Hide replies"
            : `${this.countValue} ${this.countValue === 1 ? "reply" : "replies"}`
    }
}
